import { render } from "./foilFanController.vue?vue&type=template&id=2c891a88&scoped=true"
import script from "./foilFanController.vue?vue&type=script&lang=js"
export * from "./foilFanController.vue?vue&type=script&lang=js"

import "./foilFanController.vue?vue&type=style&index=0&id=2c891a88&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c891a88"]])

export default __exports__